import { FixedNumber, utils } from 'ethers';

const formatPercent = (percent: any) => {
  return (
    Number(
      FixedNumber.from(utils.formatUnits(percent, 18))
        .mulUnsafe(FixedNumber.from(100))
        .toString(),
    ) + '%'
  );
};

export default formatPercent;
